import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const PictureIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M4.12 19.84V4.08H19.88V19.84H4.12ZM5.76 18.2H18.24V5.72H5.76V18.2ZM9.28 10.54C8.54 10.54 7.9 9.92 7.9 9.18C7.9 8.44 8.54 7.82 9.28 7.82C10.02 7.82 10.66 8.44 10.66 9.18C10.66 9.92 10.02 10.54 9.28 10.54ZM14.02 12.32L17.78 16.44H6.2L8.88 13.42L10.92 15.72L14.02 12.32Z" />
    </SvgIcon>
  );
});
